import { AxiosError } from "axios";

import api from "./instance";
import { ISignOutResponse } from "types";

const { ignoreLogin } = window.env;

const redirect = (response: any) => {

  window.location.assign(
    response.data.data.redirectUrl
  );
};

export const checkAuthorization = (e: AxiosError) => {
  if (ignoreLogin === "true") {
    return;
  }

  if (e.response?.status === 401) {
     window.location.assign(
      `${window.env.monolithDomain}${window.env.loginPath}`
    );
  }
};



export const signout = () => {
  api
    .delete<ISignOutResponse>("/api/v1/operator/sign_out", {
      withCredentials: true,
    })
    .then(redirect);
};
